import { UserRole } from 'src/enums/shared.enums';

const STORAGE_KEY = 'actingRole';
const REMEMBER_ROLE_KEY = 'rememberActingRole';

// In-memory acting role store
let currentActingRole: UserRole | null = getActingRoleFromLocalStorage();

// Set only in-memory value
export const setActingRole = (role: UserRole | null) => {
    currentActingRole = role;
};

// Get in-memory value
export const getActingRole = (): UserRole | null => currentActingRole;

// LocalStorage helpers
export const setActingRoleInLocalStorage = (roleName?: UserRole | null) => {
    if (roleName) {
        localStorage.setItem(STORAGE_KEY, roleName);
    } else {
        localStorage.removeItem(STORAGE_KEY);
    }
};

export function getActingRoleFromLocalStorage(): UserRole | null {
    return localStorage.getItem(STORAGE_KEY) as UserRole | null;
}

// Remember role preference helpers
export const setRememberRolePreference = (remember: boolean) => {
    if (remember) {
        localStorage.setItem(REMEMBER_ROLE_KEY, 'true');
    } else {
        localStorage.removeItem(REMEMBER_ROLE_KEY);
    }
};

export const getRememberRolePreference = (): boolean => {
    return localStorage.getItem(REMEMBER_ROLE_KEY) === 'true';
};

export const clearRememberRolePreference = () => {
    localStorage.removeItem(REMEMBER_ROLE_KEY);
};
